// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-overlay[data-v-93a5d6b8]{z-index:10000;top:0;right:0;position:fixed;display:flex;width:100%;height:100%;background:hsla(0,0%,100%,.5);align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
